import {ReplyEntry, UpdatePostReplyApiProps} from "../../../../types/support/board";

import ReplyEditRow from "../../../../components/common/ReplyEditRow";
import {useEditPostReply} from "../hooks/useEditPostReply";

interface ReplyEditRowProps {
    data: ReplyEntry;
    onCanceled: (key:string) => void;
    postId: string;
}

export default function BoardReplyEditRow(props: ReplyEditRowProps) {
    const {data, onCanceled, postId} = props;

    const {
        removeFile,
        handleButtonClick,
        UploadUI,
        inputData,
        setInputData,
        updatePostReply
    } = useEditPostReply({data: data, onCanceled, postId: postId});

    return <ReplyEditRow setter={setInputData}
                         data={inputData}
                         removeFile={removeFile}
                         handleButtonClick={handleButtonClick}
                         UploadUI={UploadUI}
                         updateReply={()=>updatePostReply(inputData as UpdatePostReplyApiProps)}
                         onCanceled={()=>onCanceled(inputData.postReplyId)}/>
}